import thunk from 'redux-thunk';
import {routerMiddleware} from 'react-router-redux';
import {composeWithDevTools as composeWithLocalDevTools} from 'redux-devtools-extension';
import {composeWithDevTools as composeWithRemoteDevTools} from 'remote-redux-devtools';
import {createHashHistory, createBrowserHistory} from 'history';
import {createStore as reduxCreateStore, applyMiddleware} from 'redux';

import {loggingMiddleware} from './logging';

const inFileContext = location.protocol === 'file:';

export const createStore = (reducer, preloadedState, history = null, ownMiddlewares = [],
                            name = null, useRemote = false) => {
    let middlewares = [
        thunk,
        loggingMiddleware,
        ...ownMiddlewares,
    ];

    if (history) {
        middlewares = [
            routerMiddleware(history),
            ...middlewares,
        ];
    }

    const devToolsOptions = {
        maxAge: 200,
        name,
    };

    const composeEnhancers = window.devToolsExtension || !useRemote ? composeWithLocalDevTools({
        ...devToolsOptions,
    }) : composeWithRemoteDevTools({
        ...devToolsOptions,
        id: name,
        hostname: 'localhost', // was remotedev.cosmocode.de
        port: 443,
        secure: true,
        realtime: true,
    });

    return reduxCreateStore(reducer, preloadedState, composeEnhancers(applyMiddleware(...middlewares)));
};

export const createHistory = ({basename, ...options}) => (
    (inFileContext ? createHashHistory : createBrowserHistory)({
        ...options, basename: inFileContext ? '/' : basename,
    })
);



// WEBPACK FOOTER //
// ./scripts/utils/store.js